import {config} from "@shared/_services/config";
import {HTTP} from "../_helpers/http";

export default class ContactApi {
    static get() {
        return HTTP.get(config.contactApi.contact)
            .then(response => response.data)
    }

    static post(contact) {
        return HTTP.post(config.contactApi.contact, contact)
            .then(response => response.data);
    }
}